import { useMemo } from 'react';

import { normalizeHref } from 'src/utils';

export function useNormalizedHref(href, config) {
  return useMemo(() => (href ? normalizeHref(href, config) : { href: '' }), [href]);
}
